<template>
  <section id="hero">
    <!--
    {{Hero.vue}}
      :src="require('@/assets/home-hero.jpg')"
    -->
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/images/BallstonBreachCrop.jpg')"
      class="white--text"
      gradient="65deg, rgba(5, 11, 31, .9) , rgba(5, 11, 31, .6) 50%, rgba(5, 11, 31, .1)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="CLIMATE ACTION TRURO" />

          <base-body>
            <span class="para">
              Truro sits on the Outer Cape and shares the same atmosphere as the rest of the world. We in Truro also share the same water aquifer. The air and water connect us all, and are the Climate that is above and below us. That Climate is under stress and affecting our land as well. CO2 emissions are warming the air, sea level is rising, and storms are eroding our shorelines. The purity of our drinking water is under threat from contamination. Action is needed by all of us in concerted efforts to make sure that Truro's future is a healthy and sustainable one.
            </span>
          </base-body>
          <!--
          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn>
              Discover More
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>
              class="xs='12'"
              md="6"
              offset-md="6"
            <v-card>
            </v-card>

          -->
          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              New Projects:
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wpClick"
              >
                Water Protectors<span class="hidden-lg-and-down">...</span>
              </v-btn>

              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="caClick"
              >
                Climate Activists<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>
          <!--
          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              New Projects:
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="caClick"
              >
                Climate Activists<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="xs='12'"
              sm="9"
              offset-sm="3"
            >
              New Studies:
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wellsClick"
              >
                Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="xs='12'"
              sm="9"
              offset-sm="3"
            >
              New Studies:

              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wellsClick"
              >
                Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
              </v-btn>

              <a
                href="https://docstruro.org"
                target="_blank"
              >
                Docs Truro</a> <small>(url)</small>
            </v-col>
          </v-row>
          -->
          <!--
                  @click="wellsClick"

          -->

          <v-row v-if="1==0">
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              New Studies:
              <a
                href="https://docstruro.org"
                target="_blank"
              >
                <v-btn
                  small
                  class="ml-2 mr-0 small red"
                >
                  Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
                </v-btn>

              </a> <small> from <em>Docs for Truro Safe Water</em></small>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              <h2>Act Locally, Think Globally</h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="docsClick"
              >
                Docs for Truro Safe Water<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>

          <span class="trace">Hero.vue</span>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },

    methods: {
      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },

      caClick: function (event) {
        this.$router.push({ name: 'climateActivists' })
      },

      wellsClick: function (event) {
        this.$router.push({ name: 'wells' })
      },

      docsClick: function (event) {
        // alert('Docs')
        this.$router.push({ name: 'docs' })
      },
    },
  }
</script>

<style scoped>
  .para {
    font-size: 110%;
    color: white;
  }
</style>
